import React, { useState } from 'react';
import LeftSidebar from './LeftSidebar';
import RightSidebar from './RightSidebar';

const MainLayout = ({ children }) => {
  const [searchQuery, setSearchQuery] = useState('');
  // Filter tournaments based on search query

  // Tournament data sorted by date in ascending order
  const searchrecentEvents = [
    {
      id: 1,
      date: "September 11-14",
      name: "Procore Championship",
      location: "Silverado Resort (North Course), Napa, California",
      status: "completed"
    },
    {
      id: 2,
      date: "September 26-28",
      name: "Ryder Cup",
      subtitle: "(unofficial team event on PGA Tour list)",
      location: "Bethpage State Park, Black Course, Farmingdale, New York",
      status: "completed"
    },
    {
      id: 3,
      date: "October 2-5",
      name: "Sanderson Farms Championship",
      location: "The Country Club of Jackson, Jackson, Mississippi",
      status: "completed"
    }
  ];

  const searchupcomingEvents = [
    {
      id: 4,
      date: "October 9-12",
      name: "Hero World Challenge",
      location: "Albany, Bahamas",
      status: "upcoming"
    },
    {
      id: 5,
      date: "October 16-19",
      name: "Grant Thornton Invitational",
      location: "Tiburón Golf Club, Naples, Florida",
      status: "upcoming"
    },
    {
      id: 6,
      date: "October 23-26",
      name: "World Wide Technology Championship",
      location: "El Cardonal at Diamante, Cabo San Lucas, Mexico",
      status: "upcoming"
    },
    {
      id: 7,
      date: "October 30 - November 2",
      name: "Butterfield Bermuda Championship",
      location: "Port Royal Golf Course, Southampton, Bermuda",
      status: "upcoming"
    }
  ];
  
  const searchfilteredRecentEvents = searchrecentEvents.filter(event =>
    event.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    event.location.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const searchfilteredUpcomingEvents = searchupcomingEvents.filter(event =>
    event.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    event.location.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="proskins-main">
      <LeftSidebar/>
      <div className="proskins-content">
        {/* Search Bar */}
        <div className="proskins-sidebar-search">
          <div className="proskins-search-container">
            <input
              type="text"
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="proskins-search-input"
            />
            <span className="proskins-search-icon">🔍</span>
          </div>
        </div>

        {children}
      </div>
      <div className="proskins-rightbar">
        <div className="proskins-sidebar-section">
          <RightSidebar/>
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
